module.exports = __webpack_public_path__ + "6f05808b4f6a11d3feb1716291c7c038.woff";